import DateIcon from './Icons/Date.svg';
import ShortTextIcon from './Icons/ShortText.svg';
import LongTextIcon from './Icons/LongText.svg';
import YesNoIcon from './Icons/YesNo.svg';
import ChoiceIcon from './Icons/Choice.svg';
import OpenChoiceIcon from './Icons/OpenChoice.svg';
import MedicationSearchIcon from './Icons/MedicationSearch.svg';
import PainScaleIcon from './Icons/PainScale.svg';
import PhoneNumberIcon from './Icons/PhoneNumber.svg';
import PhotoIcon from './Icons/Photo.svg';
import DisplayIcon from './Icons/Display.svg';

import {
  dateItem,
  choiceItem,
  openChoiceItem,
  stringItem,
  textItem,
  booleanItem,
  displayItem,
  phoneNumberItem,
  medicationSearchItem,
  painScaleItem,
  photoItem
} from './ItemTemplates';


export const Types = [
  'date',
  'choice',
  'open-choice',
  'string',
  'text',
  'boolean',
  'display',
  'phone-number',
  'medication-search',
  'pain-scale',
  'photo',
  'integer'
];

export function TypeFactory(type) {
  switch (type) {
    case 'date':
      return dateItem;
    case 'choice':
      return choiceItem;
    case 'open-choice':
      return openChoiceItem;
    case 'string':
      return stringItem;
    case 'text':
      return textItem;
    case 'boolean':
      return booleanItem;
    case 'display':
      return displayItem;
    case 'phone-number':
      return phoneNumberItem;
    case 'medication-search':
      return medicationSearchItem;
    case 'pain-scale':
      return painScaleItem;
    case 'photo':
      return photoItem;
    default:
      return false;
  }
}

export default {
  date: { id: 'date', name: 'Date', description: 'only date', icon: DateIcon },
  choice: { id: 'choice', name: 'Choice', description: 'Many options', icon: ChoiceIcon },
  display: { id: 'display', name: 'Display', description: 'Display instructions, link, or an image.', icon: DisplayIcon },
  longText: { id: 'text', name: 'Long Text', description: 'Multi-line text', icon: LongTextIcon },
  medicationSearch: { id: 'medication-search', name: 'Medication', description: 'Medication Search', icon: MedicationSearchIcon },
  openChoice: { id: 'open-choice', name: 'Open Choice', description: 'Choice or free text', icon: OpenChoiceIcon },
  painScale: { id: 'pain-scale', name: 'Pain Scale', description: 'Pain Scale', icon: PainScaleIcon },
  photo: { id: 'photo', name: 'Photo', description: 'Photo or Gallery', icon: PhotoIcon },
  phoneNumber: { id: 'phone-number', name: 'Phone Number', description: 'Phone Number', icon: PhoneNumberIcon },
  shortText: { id: 'string', name: 'Short Text', description: 'Single-line text', icon: ShortTextIcon },
  yesNo: { id: 'boolean', name: 'Yes No', description: 'Yes or No question', icon: YesNoIcon },
}